import NorthIcon from '@mui/icons-material/North';
import { Grid } from '@mui/material';
import { RoutalLoader, RoutalPalette } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';

import { FullPageContainer } from '../../../components/FullPageContainer';
import { useRetrieveDriverCredentials } from '../hooks/useRetrieveDriverCredentials';
import { useRetrieveVehicle } from '../hooks/useRetrieveVehicle';
import { HomeAnalyticsSummary } from './analytics-summary/HomeAnalyticsSummary';
import { Header } from './Header';
import { HomeCalendar } from './HomeCalendar';
import { HomeSlidingMenu } from './homeSlidingMenu/HomeSlidingMenu';
import { ActiveRouteNotification } from './notifications/ActiveRouteNotification';
import { HomeNotifications } from './notifications/HomeNotifications';

export const Home = () => {
  const { run: refetchVehicle } = useRetrieveVehicle();
  const { run: refetchCredentials } = useRetrieveDriverCredentials();
  const [isPreferencesOpen, setIsPreferencesOpen] = useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0); // A simple counter for refresh
  const [isScrolling, setIsScrolling] = useState(false);

  const handleRefresh = async () => {
    refetchVehicle();
    refetchCredentials();
    setRefreshTrigger((prev) => prev + 1); // Increment to trigger children re-fetch
  };

  const handleTouchEnd = () => {
    if (isScrolling) {
      setIsScrolling(false);
    }
  };

  const handleTouchMove = () => {
    if (!isScrolling) {
      setIsScrolling(true);
    }
  };

  return (
    <FullPageContainer
      style={{
        background: `linear-gradient(180deg, rgba(64, 104, 103, 0.90) 0%, #072120 21.79%)`,
      }}
    >
      <PullToRefresh
        isPullable={!isPreferencesOpen}
        onRefresh={handleRefresh}
        refreshingContent={<RoutalLoader width={24} />}
        pullingContent={
          <Grid container direction="row" alignItems="center" justifyContent="center" style={{ height: `50px` }}>
            <NorthIcon style={{ transform: `rotate(180deg)`, color: RoutalPalette.primary00 }} />
          </Grid>
        }
      >
        <>
          <HomeSlidingMenu isOpen={isPreferencesOpen} onClose={() => setIsPreferencesOpen(false)} />

          <Grid
            container
            direction="column"
            wrap="nowrap"
            style={{
              height: `100%`,
            }}
          >
            <Header onOpenPreferences={() => setIsPreferencesOpen(true)} />

            <Grid
              container
              direction="column"
              wrap="nowrap"
              style={{
                position: `relative`,
              }}
            >
              <HomeAnalyticsSummary refreshTrigger={refreshTrigger} />
              <div
                style={{
                  height: `1px`,
                  width: `100%`,
                  bottom: `10px`,
                  zIndex: 1,
                  position: `absolute`,
                  backgroundColor: `transparent`,
                  boxShadow: `0px 10px 16px 11px #072120`,
                }}
              />
            </Grid>

            <Grid
              container
              direction="column"
              wrap="nowrap"
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onTouchStart={handleTouchMove}
              style={{
                flex: 1,
                overflowY: `auto`,
                padding: `20px 0`,
              }}
            >
              <ActiveRouteNotification refreshTrigger={refreshTrigger} />

              <HomeCalendar refreshTrigger={refreshTrigger} parentIsScrolling={isScrolling} />

              <HomeNotifications refreshTrigger={refreshTrigger} onOpenPreferences={() => setIsPreferencesOpen(true)} />
            </Grid>
          </Grid>
        </>
      </PullToRefresh>
    </FullPageContainer>
  );
};
